import { Injectable } from "@angular/core";
import { ApiConfig } from "../config/apiConfig";
import { of, Observable, BehaviorSubject } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { ConfService } from 'src/conf.service';
import { tap } from "rxjs/internal/operators/tap";
import { UserLocationFacility } from "../models/facility/userFacility";
import { DevicebrowserService } from "../services/devicebrowser.service";
import { UserDetail, AccessUserInfo } from "../models/user/UserInfo";
@Injectable({
  providedIn: "root",
})
export class FacilityService {
  public userInfo: UserDetail;
  private rootUrl: string;
  private facilityAPIUrl;
  private browserName: string = null;
  constructor(
    private http: HttpClient,
    private deviceService: DevicebrowserService
  ) {
    this.rootUrl = ConfService.conf.environment.apiRootUrl;
    this.facilityAPIUrl = ApiConfig.FacilityApiConfig;
    if (this.deviceService.getBrowserName()) {
      this.browserName = this.deviceService.getBrowserName().toLowerCase();
      console.log("Application Open In " + this.browserName);
    }
   
  }
  getCurrentUserFacilityMasterIdList() {
    //return localStorage.getItem("userFacilityIdList")
    //Start:Added By Harikesh on 16-Oct-2020  for Defect#12291
    let strUserFacility: string = "0";
    let data = JSON.parse(localStorage.getItem("getUserLocations"));
    if (data != null) {
      let objUserFacilities: UserLocationFacility[] = data.facilities;
      if (objUserFacilities != null && objUserFacilities.length > 0) {
        strUserFacility = objUserFacilities
          .map((x) => x.FacilityMasterID)
          .join(", ");
      }
    }
    return strUserFacility;
    //End:Added By Harikesh on 16-Oct-2020  for Defect#12291
  }

  getUserFacilities(facilityObj: any): Observable<any> {
    //#region Start:Assign LOCATION_ID_LIST
    this.userInfo = AccessUserInfo.getUserInfo();
    let objJson = JSON.parse(facilityObj);
    objJson.GETUSERFACILITIES.LOCATION_ID_LIST =
      this.userInfo.assignedFacilityNumbers;
    facilityObj = JSON.stringify(objJson);
    //#endregion End:Assign LOCATION_ID_LIST
    return this.http
      .post(
        `${ConfService.conf.environment.apiRootUrl}${this.facilityAPIUrl.getUserFacilities}`,
        facilityObj
      )
      .pipe(
        tap((resolvedValue) => {
        })
      );
  }

  getUserLocations(facilityObj: any): Observable<any> {
    //#region Start:Assign LOCATION_ID_LIST
    this.userInfo = AccessUserInfo.getUserInfo();
    let objJson = JSON.parse(facilityObj);
    objJson.GETUSERLOCATIONS.LOCATION_ID_LIST =
      this.userInfo.assignedFacilityNumbers;
    facilityObj = JSON.stringify(objJson);
    //#endregion End:Assign LOCATION_ID_LIST
    if (this.browserName == "safari") {
      return this.http
        .post(
          `${this.rootUrl}${this.facilityAPIUrl.getUserLocations}`,
          facilityObj
        )
        .pipe(tap(() => {}));
    } else {
      let key = "getUserLocations";
      if (localStorage.getItem(key)) {
        return of(JSON.parse(localStorage.getItem(key)));
      }
      return this.http
        .post(
          `${this.rootUrl}${this.facilityAPIUrl.getUserLocations}`,
          facilityObj
        )
        .pipe(
          tap((resolvedValue) => {
            //
            localStorage.setItem(key, JSON.stringify(resolvedValue));
          })
        );
    }
  }

  getFacilityInfo(facilityObj: object): Observable<any> {
    return this.http
      .post(
        `${ConfService.conf.environment.apiRootUrl}${this.facilityAPIUrl.getFacilityInfo}`,
        facilityObj
      )
      .pipe(
        tap(() => {
          //
        })
      );
  }

  getFilteredFacilityDetails(facilityObj: object): Observable<any> {
    return this.http
      .post(
        `${ConfService.conf.environment.apiRootUrl}${this.facilityAPIUrl.getFilteredFacilityDetails}`,
        facilityObj
      )
      .pipe(
        tap(() => {
          //
        })
      );
  }

  getLocationTypeId(facilityObj: object): Observable<any> {
    return this.http
      .post(
        `${ConfService.conf.environment.apiRootUrl}${this.facilityAPIUrl.getLocationTypeId}`,
        facilityObj
      )
      .pipe(
        tap(() => {
          //
        })
      );
  }
 getUserLocationFacilities(userName, callBack) {
    let getLocationParam = {
      GETUSERLOCATIONS: {
        LOCATION_ID_LIST: null,
        USERNAME: userName,
      },
      GETUSERLOCATIONS2: {
        USERNAME: userName,
      },
    };
    this.getUserLocations(JSON.stringify(getLocationParam)).subscribe(
      (resp: any) => {
        if (resp.facilities) {
          callBack(resp.facilities);
        } else {
          callBack([]);
        }
      },
      (error) => {
        console.log("Error: " + error);
        callBack([]);
      }
    );
  }
}
